import type { NodeHandle } from '@/models/logic/RuntimeHandles';
import type { IEventBus } from '@/interfaces/models';

export type EventHandler = (nodeId: NodeHandle, reason?: string) => void;

export class EventBus implements IEventBus {
  private handlers = new Set<EventHandler>();

  subscribe(handler: EventHandler) {
    this.handlers.add(handler);
    return () => { this.handlers.delete(handler); };
  }

  trigger(nodeId: NodeHandle, reason?: string) {
    this.handlers.forEach((handler) => handler(nodeId, reason));
  }
}
